<template>
  <div class="jobs-body-inspector" style="display: flex; flex-direction: column;">
    <div class="jobs-body-inspector__details">
      <strong>{{ preloadJob ? 'Updating' : 'Create'}} {{ !jobObject.isRelease ? 'Template' : 'Release' }}:</strong>
      <div class="jobs-body-inspector__job-item">
        <div class="create-job__list-item" style="margin-bottom: 2.5em;">
          <h4 style="margin-right: .25em;">Label & Notes:</h4><br>
          <small style="font-style: italic;">
            These fields are required. <br>
            Generate a label for this template or release. Generate at least 1 note. <br>
            Is this a release or a generic template? Configure below.
          </small>
          <br>
          <br>
          <span style="display: block; margin-bottom: 5px;">
            <b>Is Release?</b>
            <input style="display: block;" type="checkbox" v-model="jobObject.isRelease">
          </span>
          <span style="display: block; margin-bottom: 5px;">
            <b>Label</b>
            <input style="display: block;"
              v-model="jobObject.templateLabel" /> 
          </span>
          <span style="display: block; margin-bottom: 5px;">
            <b>Notes</b>
            <textarea v-model="jobObject.templateNotes" class="text-area" contenteditable="true">
  
            </textarea>
          </span>

        </div>

        <div v-if="createConfig && Array.isArray(createConfig.jobs)" class="create-job__list-item" style="margin-bottom: 2.5em;">
          <h4 style="margin-right: .25em;">Pre-requisites:</h4><br>
          <small style="font-style: italic;">
            Selecting these options will send the desired selections to the devices that match in the filter in a seperate & immediate job.<br>
            These selections will run silently and not lock the device unless immediate is selected as the schedule. In that case, the selections are simply prepended to the job.<br>
            If no devices are compatable with these selections, it will be skipped.
          </small>
          <br>
          <br>
          <span v-if="createConfig && Array.isArray(createConfig.jobs) && Array.isArray(createConfig.applications)">
            <span v-for="silentJob in createConfig.jobs.filter((job) => job.isSilentJob)" :key="silentJob.displayName" style="display: block; margin-bottom: 5px;">
              <input
                :value="jobObject.silentOptionsSelected.find((selected) => selected.actionType === silentJob.actionType && selected.category === silentJob.category) || jobObject.tasks.find(task => task.requires === silentJob.category) || silentJob"
                type="checkbox"
                :checked="jobObject.silentOptionsSelected.find((selected) => selected.actionType === silentJob.actionType && selected.category === silentJob.category) || jobObject.tasks.find(task => task.requires === silentJob.category)"
                :disabled="jobObject.tasks.find(task => task.requires === silentJob.category)"
                :name="`checkbox-${silentJob.displayName}`"
                v-model="jobObject.silentOptionsSelected" 
                @change="() => {
                  if (Array.isArray(jobObject.silentOptionsSelected)) {
                    jobObject.silentOptionsSelected.forEach((job) => {
                      job.applications = createConfig.applications.filter((app) => app.category === job.category);
                    })
                  }
                }"/> 
                {{ silentJob.displayName }} 

                <div v-if="jobObject.silentOptionsSelected.find((selected) => selected.actionType === silentJob.actionType && selected.category === silentJob.category) || jobObject.tasks.find(task => task.requires === silentJob.category)">
                  <div v-for="app in createConfig.applications.filter((app) => app.category === silentJob.category)" :key="app.appName" style="margin-bottom: 15px; margin-top: 15px;">
                    <div v-if="Array.isArray(app.subModels)"><strong>[ Submodels: {{ app.subModels.join(', ').toUpperCase() }}]</strong></div>
                    <div><strong>{{ app.appName }}</strong></div>
                    <div v-if="app.appVersionId && Array.isArray(app.versions) && app.versions.find((version) => version.id === app.appVersionId)">
                      <strong v-if="app.versions.find((version) => version.id === app.appVersionId).code">Version:</strong>
                    </div>
                    <select v-if="app.appVersionId && Array.isArray(app.versions)" :value="app.appVersionId" @change="(event) => {
                      (jobObject.silentOptionsSelected.find((selected) => selected.actionType === silentJob.actionType && selected.category === silentJob.category) || jobObject.tasks.find(task => task.requires === silentJob.category)).appVersionId = event.target.value;
                      app.appVersionId = event.target.value;
                      updateReleaseConfiguration(createConfig).then();
                    }">
                      <option v-for="version in app.versions" :key="version.code + version.comment" :value="version.id">
                        {{ version.code }} ({{ version.comment }})
                      </option>
                    </select>
                    <br>
                  </div>
                </div>
            </span>
          </span>
        </div>

        <div v-if="createConfig && Array.isArray(createConfig.jobs)" class="create-job__list-item">
          <h4 style="margin-right: .25em;">Tasks:</h4> <br>
          <small style="font-style: italic;">When the {{ !jobObject.isRelease ? 'template' : 'release' }} is executed, it will process each task below in the order selected until all are complete.</small>
          <br>
          <br>
          <button v-b-tooltip.hover :title="task.displayName" 
            class="btn-primary btn-margin jobs-body__tab-item--button" 
            style="margin-top: 0.25em; margin-right: 0.25em; padding: 0.25em; border-radius: 5px;" 
            v-for="task in createConfig.jobs.filter((job) => ['task', 'custom'].includes(job.category) && (!job.unique || (job.unique  && !jobObject.tasks.find(existing => existing.type === job.actionType))))" :value="task" :key="task.actionType" @click="() => {
              if (task.isCustomJob) {
                jobObject.tasks.push({ type: task.actionType, custom: task, requires: task.requires });
              } else jobObject.tasks.push({ type: task.actionType, validator: task.payload, isNonLocking: task.isNonLocking, options: task.options, requires: task.requires});
            }">
            {{ task.actionType }}
          </button> 
        </div>

        <div v-if="!createConfig || !Object.keys(createConfig).length" style="flex: 1; display: flex; justify-content: center; align-items: flex-start; flex-direction: column; margin-bottom: 2.5em;">
          <h4 style="margin-right: .25em;">Configuration loading...</h4><br>
          <img src="../../assets/images/loader-a2.gif" alt="Loading items" width="100px" style="opacity: .8; margin-top: .5em;" />
        </div>

        <div class="create-job__list-item" style="margin-bottom: 2.5em;">
          <div class="jobs-body-inspector__job-item" :style="{ 'background': isCreateValid ? 'rgb(0 255 123 / 5%)' : 'rgb(255 0 0 / 10%)' }">
            <div class="create-job__list-item">
              <div class="create-job__list-item">
                <h5 style="margin-right: .25em;">Preview {{ !jobObject.isRelease ? 'Template' : 'Release' }} ({{ isCreateValid ? 'Valid' : 'Invalid' }}):</h5> 
                <div v-if="Array.isArray(validationErrors) && validationErrors.length" style="font-size: 10px; font-style: italic;" v-for="(err, index) in validationErrors" :value="index" :key="index">
                  <b>Validation Issue:</b> {{ err }}
                </div>
                <br>
                <small style="font-style: italic; margin-bottom: .25em;">When the {{ !jobObject.isRelease ? 'template' : 'release' }} is executed, it will process the previewed object below. Once it triggers, this job will repeat indefinitely until completed or is cancelled. There are some conditions in which a device may not receive the job immediately such as it offline or it being locked because it is in use or in some other maintenance.</small>
                <br>

                <h5 style="margin-top: 1.5em;">{{ !jobObject.isRelease ? 'Template' : 'Release' }} Label:</h5>
                <strong>{{jobObject.templateLabel}}</strong>

                <h5 style="margin-top: 1.5em;">{{ !jobObject.isRelease ? 'Template' : 'Release' }} Notes:</h5>
                <strong v-html="jobObject.templateNotes"></strong>
                
                <div v-if="jobObject && Array.isArray(jobObject.silentOptionsSelected)">
                  <h5 style="margin-top: 1.5em;">Pre-Requisites:</h5>
                  <div class="jobs-body-inspector__job-item" style="position: relative;" v-for="(task) in jobObject.silentOptionsSelected" :value="task" :key="task">
                    <span v-if="createConfig && Array.isArray(createConfig.jobs) && Array.isArray(createConfig.applications)">
                      <span v-for="silentJob in createConfig.jobs.filter((job) => job.isSilentJob)" :key="silentJob.displayName" style="display: block; margin-bottom: 5px;">
                          <div v-if="jobObject.silentOptionsSelected.find((selected) => selected.actionType === silentJob.actionType && selected.category === silentJob.category) || jobObject.tasks.find(task => task.requires === silentJob.category)">
                            <div v-for="app in createConfig.applications.filter((app) => app.category === silentJob.category)" :key="app.appName" style="margin-bottom: 15px; margin-top: 15px;">
                              <div v-if="Array.isArray(app.subModels)"><strong>[ Submodels: {{ app.subModels.join(', ').toUpperCase() }}]</strong></div>
                              <div><strong>{{ app.appName }}</strong></div>
                              <div v-if="app.appVersionId && Array.isArray(app.versions) && app.versions.find((version) => version.id === app.appVersionId)">
                                <strong v-if="app.versions.find((version) => version.id === app.appVersionId).code">Version:</strong> 
                                {{ app.versions.find((version) => version.id === app.appVersionId).code }} 
                                <span v-if="app.versions.find((version) => version.id === app.appVersionId).comment">
                                  ({{ app.versions.find((version) => version.id === app.appVersionId).comment }})
                                </span>
                              </div>
                              <br>
                            </div>
                          </div>
                      </span>
                    </span>
                  </div>
                </div>

                <div v-if="jobObject && Array.isArray(jobObject.tasks)">
                  <h5 style="margin-top: 1.5em;">Tasks:</h5>
                  <div class="jobs-body-inspector__job-item" style="position: relative;" v-for="(task, index) in jobObject.tasks" :value="task" :key="task">
                    <div style="position: absolute; top: 1em; right: 1em; cursor: pointer; color: #c75353;"  @click="removeTaskItem(index)">
                      X
                    </div>

                    <!-- List Task Type Forms -->
                    <div v-if="task.type === 'add-wifi-ap'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Add Wifi</h6> <br>
                      <h6>SSID</h6>
                      <input v-model="task.wifi_ssid" />
                      <h6 >Security</h6>
                      <select v-model="task.wifi_security_type" >
                        <option value="">Select a WIFI security configuration</option>
                        <option v-for="wifiSec in createConfig.supportedWifiSecurity" :value="wifiSec" :key="wifiSec">
                          {{ wifiSec }}
                        </option>
                      </select>
                      <h6>Password</h6>
                      <input v-model="task.wifi_password" type="password" />
                      <h6>Hidden Network</h6>
                      <select :value="false" v-model="task.hidden" >
                        <option value="">Select if Wireless Network is hidden</option>
                        <option :value="true">Yes</option>
                        <option :value="undefined">No</option>
                      </select>
                    </div>

                    <div v-if="task.type === 'remove-wifi-ap'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Remove Wifi</h6> <br>
                      <h6 >SSID to be removed</h6>
                      <input v-model="task.wifi_ssid" />
                    </div>

                    <div v-if="task.type === 'install-app'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Install App</h6> <br>
                      
                      <h6>App Name</h6>
                      <select v-model="task.appName">
                        <option value="">Select a package</option>
                        <option v-for="application in [...createConfig.applications].sort((a, b) => a.appName.localeCompare(b.appName))" :value="application.appName" :key="application.appId">
                          {{ application.displayName }} ({{ application.appName }})
                        </option>
                      </select>
                      <div v-if="task.details" style="margin-top: .5em;">
                        <h6 >App Version (Optional)</h6>
                        <select v-if="createConfig.applications && task.appName && task.details" v-model="task.appVersion">
                          <option value="">Latest Version</option>
                          <option v-for="version in task.details.sort((a, b) => b.version_code.localeCompare(a.version_code))" :value="version.version_code" :key="version.id">
                            {{ version.version_code }} ({{ version.id }})
                          </option>
                        </select>
                      </div>
                    </div>

                    <div v-if="task.type === 'uninstall-app'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Uninstall App</h6> <br>

                      <h6 >App Name</h6>
                      <select v-model="task.appName">
                        <option value="">Select a package</option>
                        <option v-for="application in [...createConfig.applications].sort((a, b) => a.appName.localeCompare(b.appName))" :value="application.appName" :key="application.appId">
                          {{ application.displayName }} ({{ application.appName }})
                        </option>
                      </select>
                    </div>

                    <div v-if="task.type === 'set-app-state'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Set App State</h6> <br>
                      <h6 >App Name</h6>
                      <select v-model="task.appName">
                        <option value="">Select a package</option>
                        <option v-for="application in [...createConfig.applications].sort((a, b) => a.appName.localeCompare(b.appName))" :value="application.appName" :key="application.appId">
                          {{ application.displayName }} ({{ application.appName }})
                        </option>
                      </select>
                      <h6 >State</h6>
                      <select v-model="task.appState">
                        <option value="">Select App State</option>
                        <option>SHOW</option>
                        <option>HIDE</option>
                        <option>DISABLE</option>
                      </select>
                    </div>

                    <div v-if="task.type === 'set-kiosk-mode'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Set App Kiosk Mode</h6> <br>
                      <h6 >App Name</h6>
                      <select v-model="task.appName">
                        <option value="">Select a package</option>
                        <option v-for="application in [...createConfig.applications].sort((a, b) => a.appName.localeCompare(b.appName))" :value="application.appName" :key="application.appId">
                          {{ application.displayName }} ({{ application.appName }})
                        </option>
                      </select>
                    </div>

                    <div v-if="task.type === 'reboot'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Reboot</h6> <br>
                    </div>

                    <div v-if="task.type === 'delay'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Delay</h6> <br>
                      <h6 >Minutes</h6>
                      <input style="cursor: default;" aria-label="Delay task minutes" v-bind:value="task.minutes" v-on:input="($event) => {
                        if ($event.target.value != '') {
                          if (parseInt($event.target.value) < parseInt($event.target.min)) {
                            $event.target.value = $event.target.min;
                          }
                          if (parseInt($event.target.value) > parseInt($event.target.max)) {
                            $event.target.value = $event.target.max;
                          }
                          task.minutes = $event.target.value;
                          isCreateValid = isValid(jobObject).valid
                        }
                      }" @keydown="handleKeydown" min="1" max="60" type="number">
                    </div>

                    <div v-if="task.type === 'deploy-models'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Deploy Model</h6> 
                      <br>
                      <p>Note: This task type operates silently. If the job only contains silent task types it will not lock the device.</p>
                      <p>Note: This is an iot-job, at this time we only offer that the job was successfully created. It makes no promise or status update related to 
                        it actually executing once received on the device.</p>
                      <br>
                      <h6>Model Name</h6>
                      <select v-model="task.modelName">
                        <option value="">Select a model</option>
                        <option v-for="option in [...task.options]" :value="option.label" :key="option.label">
                          {{ option.label }}
                        </option>
                      </select>
                      <div v-if="task.modelName" style="margin-top: .5em;">
                        <h6>Model Version</h6>
                        <select v-if="[...task.options].find((option) => option.label === task.modelName)" v-model="task.s3URI">
                          <option value="">Latest Version</option>
                          <option v-for="option in [...task.options].find((option) => option.label === task.modelName).subOptions" :value="option.fullPath" :key="option.fileName">
                            {{ option.fileName }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div v-if="task.type === 'iot-job'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - IOT Job</h6> <br>
                      <p>Note: This must be a valid JSON string such as {"command": "hard-reboot"}, the validator attempts to parse the string. If it fails to parse, it will show invalid.</p>
                      <br>
                      <h6 >Payload</h6>
                      <textarea :value="task.objectString" v-on:input="($event) => {
                        task.objectString = $event.target.value;
                        if ($event.target.value != '') {
                          try {
                            task.object = JSON.parse($event.target.value);
                          } catch {
                            task.object = null;
                          } finally {
                            isCreateValid = isValid(jobObject).valid;
                          }
                        }
                      }" v-on:keyup="($event) => {
                        task.objectString = $event.target.value;
                        if ($event.target.value != '' && $event.target.value) {
                          try {
                            task.object = JSON.parse($event.target.value);
                          } catch {
                            task.object = null;
                          }
                        } else {
                          task.object = null;
                        }
                        isCreateValid = isValid(jobObject).valid;
                      }"></textarea>
                    </div>

                    <div v-if="task.type === 'launch-upgrade'">
                      <h6 style="margin-right: .25em;">Task {{index + 1}} - Launch Upgrade</h6> <br>
                    </div>

                    <!-- End List Take Type Forms -->
                  </div>
                </div>
                
                <button v-if="isCreateValid" @click="preloadJob ? updateTemplate() : submitJob()" class="btn-primary btn-margin jobs-body__tab-item--button" style="margin-top: 2.5em; margin-right: .25em; padding: .25em; border-radius: 5px;">
                  {{preloadJob ? 'Update' : 'Submit'}} {{ !jobObject.isRelease ? 'Template' : 'Release' }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";  
import Multiselect from "vue-multiselect";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import "vue-loading-overlay/dist/vue-loading.css";
import { IOT_JOB_PAYLOAD, DEPLOY_MODELS_PAYLOAD } from "./JobEnums";
const moment = require("moment");

Vue.use(VueToast);
Vue.use(Loading);
Vue.component("multiselect", Multiselect);

export default {
  name: "CreateJob",
  components: { Multiselect, ModelSelect },
  data() {
    return {
      console: console,
      refreshKey: 0,
      moment: moment,
      validationErrors: [],
      createConfig: {},
      jobObject: {
        templateLabel: null,
        templateNotes: null,
        tasks: [],
        tenant: null,
        user: {
          id: null,
          first: null,
          last: null,
          email: null,
          phone: null,
        },
        isValid: false,
        silentOptionsSelected: [],
      },
      isCreateValid: false,
    };
  },
  watch: { 
    jobObject: {
      deep: true,
      handler (job) {
        const handler = async (job) => {
          this.isCreateValid = this.isValid(job).valid;
          if (job && Array.isArray(job.tasks)) {
            for (let i = 0; i < job.tasks.length; i++) {
              const task = job.tasks[i];
              if (!task.details && task.type === 'install-app' && task.appName) {
                const applicationId = this.createConfig.applications.find((item) => item.appName === task.appName).appId;
                const response = await this.fetchEdgeApplicationDetails(applicationId);
                task.details = response;
                this.$forceUpdate();
              }
              if (task.requires && !this.jobObject.silentOptionsSelected.find((silentJob) => silentJob.category === task.requires)) {
                const silentJobs = this.createConfig.jobs.filter((job) => job.isSilentJob && job.category === task.requires);
                this.jobObject.silentOptionsSelected = [...this.jobObject.silentOptionsSelected, ...silentJobs]
                this.jobObject.silentOptionsSelected.forEach((job) => {
                  job.applications = this.createConfig.applications.filter((app) => app.category === job.category);
                });
              }
            }
          }
        }
        handler(job).then();
      }
    },
    createConfig: {
      deep: true,
      handler  () {     
        this.isValid(this.jobObject);
      }
    },
  },
  mounted() {
    this.fetchCreationConfiguration().then(() => {
      if (this.preloadJob) {
        const prerequisites = [];
        if (Array.isArray(this.preloadJob.prerequisites)) {
          this.preloadJob.prerequisites.forEach((job) => {
            const app = this.createConfig.applications.find((configApp) => configApp.appId === job.applicationId);
            app.appVersionId = job.releaseVersionId;
            if (!prerequisites.find((prereq) => prereq.category === job.category)) {
              const config = this.createConfig.jobs.find((configJob) => configJob.actionType === job.type && job.isSilentJob && job.category === configJob.category);
              prerequisites.push(config);
            } 

          });
        }
        const jobObject = {
          isRelease: !this.preloadJob.isTemplate,
          templateLabel: this.preloadJob.label,
          templateNotes: this.decodeHTMLEntities(this.preloadJob.notes),
          tasks: this.preloadJob.job.map((job) => {
            const config = this.createConfig.jobs.find((configJob) => configJob.actionType === job.type && ['task','custom'].includes(configJob.category));
            job.validator = config && config.payload ? config.payload : null;
            job.isNonLocking = config && config.isNonLocking ? config.isNonLocking : null;
            let res = {
              ...config,
              ...job,
            };
            if (config.category === 'custom') res.custom = config;
            if (config) {
              if (config.actionType === 'iot-job' && job.payload && job.payload.args) {
                res = { ...res, object: job.payload.args };
              } else if ('deploy-models' === job.type && job.payload.s3URI) { 
                res = { ...res, s3URI: job.payload.args.s3URI };
              } else if ('add-wifi-ap' === config.actionType && job.payload && job.payload.ap && Array.isArray(job.payload.ap)) {
                res = { ...res, ...job.payload.ap[0] };
              } else if ('remove-wifi-ap' === config.actionType && job.payload && job.payload.ap && Array.isArray(job.payload.ap)) {
                res = { ...res, wifi_ssid: job.payload.ap[0] };
              } else {
              res = { ...res, ...job.payload };
              }
            } else {
              res = { ...res, ...job.payload };
            }
            return res;
          }),
          tenant: null,
          user: {
            id: null,
            first: null,
            last: null,
            email: null,
            phone: null,
          },
          isValid: false,
          silentOptionsSelected: prerequisites
        };
        this.jobObject = jobObject;
        this.$forceUpdate();
      }
    });
  },
  methods: {
    decodeHTMLEntities(text) {
      const parser = new DOMParser();
      const decodedText = parser.parseFromString(text.replace(/<br\s*\/?>/gi, '\n'), 'text/html').documentElement.textContent;
      return decodedText;
    },
    async fetchCreationConfiguration() {
      this.job = null;
      if (!this.$auth.isAuthenticated) {
        return;
      }

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/sensors/jobs/create-configuration`, 
        {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const response = await fetch(request);
        if (response.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (response.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if ([502, 503, 500].includes(response.status)) {
            return this.fetchCreationConfiguration();
          }
        if (response.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        } else {
          // GET
          this.createConfig = JSON.parse(JSON.stringify(await response.json()));
        }
      } catch (tex) {
        Vue.$toast.open({message: 'Failed to get jobs due to an error.', type: 'error'});
      }
    },

    async updateReleaseConfiguration(payload) {
      if (!this.$auth.isAuthenticated) {
        return;
      }

      delete payload._id;
      payload = { ...payload };
      payload.applications = payload.applications.filter((app) => app.category);

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/sensors/jobs/create-configuration`, 
        {
          method: 'PUT',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          body: JSON.stringify(payload),
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const response = await fetch(request);
        if (response.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (response.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if ([502, 503, 500].includes(response.status)) {
          return this.updateReleaseConfiguration(payload);
        }
        if (response.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        }
      } catch (tex) {
        Vue.$toast.open({message: 'Failed to get update job config due to an error.', type: 'error'});
      }
    },

    async fetchEdgeApplicationDetails(appId) {
      this.job = null;
      if (!this.$auth.isAuthenticated) {
        return;
      }

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/esper/${appId}/details`, 
        {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const response = await fetch(request);
        if (response.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (response.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if (response.status == 502) {
            return this.fetchEdgeApplicationDetails();
        }
        if (response.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        } else {
          // GET
          return JSON.parse(JSON.stringify(await response.json()));
        }
      } catch (tex) {
        Vue.$toast.open({message: 'Failed to get jobs due to an error.', type: 'error'});
      }
    },

    async removeTaskItem(index) {
      this.jobObject.tasks.splice(index, 1);
    },

    requiredPrereq(prereq) {
      return this.jobObject && this.jobObject.tasks && this.jobObject.tasks.find((job) => job.requires === prereq && job.selected) ? true : false;
    },

    isValid(job) {
      let res = {
        valid: true,
        failed: ['Job tasks are invalid'],
      };
      if (!job) res.failed.push('Job not valid');
      if (!job.templateLabel) res.failed.push('Job template label is invalid');
      if (!job.templateNotes) res.failed.push('Job template notes are invalid');
      if (Array.isArray(job.tasks) && job.tasks.length) {
        let valid = true;
        job.tasks.forEach((task) => {
          if (task.validator) {
            Object.keys(task.validator).forEach((taskProp) => {
              if (
                (
                  !task.hasOwnProperty(taskProp) && task.validator[taskProp] !== 'boolean' && [true, false].includes(task[taskProp]) || 
                  (
                    !task[taskProp] && typeof task[taskProp] === task.validator[taskProp]
                  ) || 
                  typeof task[taskProp] !== task.validator[taskProp]
                ) && !taskProp.startsWith('?')
              ) {
                valid = false;
              }
            });
          }
        })
        if (valid) res.failed = res.failed.filter((failItem) => failItem !== 'Job tasks are invalid');
      }
      this.validationErrors = res.failed;

      if (res.failed.length) res.valid = false;
      return res;
    },  

    resetJobObject() {
      this.jobObject = {
        templateLabel: null,
        templateNotes: null,
        tasks: [],
        tenant: null,
        user: {
          id: null,
          first: null,
          last: null,
          email: null,
          phone: null,
        },
        isValid: false,
        silentOptionsSelected: [],
      }
    },

    handleKeydown(event) {
      // Allow arrow keys and prevent other key inputs
      const allowedKeys = ['ArrowUp', 'ArrowDown'];
      if (event && event.key && !allowedKeys.includes(event.key)) {
        event.preventDefault(); // Prevent other key inputs
      }
    },

    async submitJob() {
      const result = confirm("Are you sure you want to submit this template? Please review carefully.");
      if (result) {
        const mappedTasks = this.jobObject.tasks.map((task) => {
          const formatted = { type: task.type, payload: undefined, isSilent: task.isNonLocking };
          const payload = {};
          if (task.validator && !task.hasOwnProperty('custom')) {
            Object.keys(task.validator).forEach((property) => {
              const propertyReplacement = property.replace('?', '');
              if (task.hasOwnProperty(propertyReplacement)) {
                if (typeof task[propertyReplacement] === 'string') {
                  payload[propertyReplacement] = task[propertyReplacement].split('|')[0];
                } else {
                  payload[propertyReplacement] = task[propertyReplacement];
                }
              }
            });
          } else if (task.hasOwnProperty('custom')) {
            formatted.custom = {
                ...task.custom,
                tasks: task.custom.subJob
            }
            delete formatted.custom.subJob;
          }
          if (Object.keys(payload).length) {
            // You can format / transform tasks to spec here if needed.
            if ('add-wifi-ap' === task.type) {
              formatted.payload = {ap: [payload]};
            } else if ('remove-wifi-ap' === task.type) {
              formatted.payload = {ap: [payload.wifi_ssid]};
            } else if ('iot-job' === task.type && payload.object) { 
              formatted.payload = { ...IOT_JOB_PAYLOAD, args: payload.object}
            } else if ('deploy-models' === task.type && payload.s3URI) { 
              formatted.payload = { ...DEPLOY_MODELS_PAYLOAD };
              formatted.payload.args = { ...DEPLOY_MODELS_PAYLOAD.args, s3URI: payload.s3URI };
            } else {
              formatted.payload = payload;
            }
          }
          return formatted;
        });

        // There is an error on the esper side that wont allow you to downgrade apps without uninstalling first. It says "A newer version already exists".
        // By default, we can uninstall apps first and it should not impact.
        let formattedTasks = [];
        mappedTasks.forEach((task) => {
          formattedTasks.push(task);
        });

        const payload = {
          isTemplate: !this.jobObject.isRelease,
          templateLabel: this.jobObject.templateLabel,
          templateNotes: this.jobObject.templateNotes
            .replace(/ /g, '&nbsp;')                       // Convert spaces to &nbsp;
            .replace(/\n/g, '<br>')                        // Convert newlines to <br>
            .replace(/^-|\*/gm, '<li>')                    // Convert bullets to <li>
            .replace(/(<li>.*<\/li>\n?)/g, '<ul>$1</ul>'), // Wrap <li> in <ul>
          job: formattedTasks,
        }

        // Apply PreReqs to Job Request
        if (Array.isArray(this.jobObject.silentOptionsSelected)) {
          payload.prerequisites = [];
          this.jobObject.silentOptionsSelected.forEach((prereq) => {
            if (Array.isArray(prereq.applications)) {
              prereq.applications.forEach((prereqApp) => {
                const version = prereqApp.versions.find((ver) => ver.id === prereqApp.appVersionId);
                payload.prerequisites.push({
                  "key": prereqApp.appName,
                  "subModels": prereqApp.subModels,
                  "releaseVersion": version.code ? version.code : null,
                  "releaseVersionId": version.id ? version.id : null,
                  "category": prereq.category,
                  "type": prereq.actionType,
                  "isSilentJob": true,
                  "applicationId": prereqApp.appId,
                });
              })
            }
          })
        }

        if (!this.$auth.isAuthenticated) {
          return;
        }

        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/sensors/jobs/templates`, 
          {
            method: 'POST',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            body: JSON.stringify(payload),
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to POST Job
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 502) {
              return this.submitJob();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // GET
            await response.json();
            alert('Template/release created.');
            this.$emit('return');
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get jobs due to an error.', type: 'error'});
        }
      }
    },

    async updateTemplate() {
      const result = confirm("Are you sure you want to update this template? Please review carefully.");
      if (result) {
        const mappedTasks = this.jobObject.tasks.map((task) => {
          const formatted = {type: task.type, payload: undefined};
          const payload = {};
          if (task.validator && !task.hasOwnProperty('custom')) {
            Object.keys(task.validator).forEach((property) => {
              const propertyReplacement = property.replace('?', '');
              if (task.hasOwnProperty(propertyReplacement)) {
                if (typeof task[propertyReplacement] === 'string') {
                  payload[propertyReplacement] = task[propertyReplacement].split('|')[0];
                } else {
                  payload[propertyReplacement] = task[propertyReplacement];
                }
              }
            });
          } else if (task.hasOwnProperty('custom')) {
            formatted.custom = {
                ...task.custom,
                tasks: task.custom.subJob
            }
            delete formatted.custom.subJob;
          }
          if (Object.keys(payload).length) {
            // You can format / transform tasks to spec here if needed.
            if ('add-wifi-ap' === task.type) {
              formatted.payload = {ap: [payload]};
            } else if ('remove-wifi-ap' === task.type) {
              formatted.payload = {ap: [payload.wifi_ssid]};
            } else if ('iot-job' === task.type && payload.object) { 
              formatted.payload = { ...IOT_JOB_PAYLOAD, args: payload.object}
            } else if ('deploy-models' === task.type && payload.s3URI) { 
              formatted.payload = { ...DEPLOY_MODELS_PAYLOAD };
              formatted.payload.args.s3URI = payload.s3URI;
            } else {
              formatted.payload = payload;
            }
          }
          return formatted;
        });

        // There is an error on the esper side that wont allow you to downgrade apps without uninstalling first. It says "A newer version already exists".
        // By default, we can uninstall apps first and it should not impact.
        let formattedTasks = [];
        mappedTasks.forEach((task) => {
          formattedTasks.push(task);
        });

        const payload = {
          isTemplate: !this.jobObject.isRelease,
          label: this.jobObject.templateLabel,
          notes: this.jobObject.templateNotes
            .replace(/ /g, '&nbsp;')                       // Convert spaces to &nbsp;
            .replace(/\n/g, '<br>')                        // Convert newlines to <br>
            .replace(/^-|\*/gm, '<li>')                    // Convert bullets to <li>
            .replace(/(<li>.*<\/li>\n?)/g, '<ul>$1</ul>'), // Wrap <li> in <ul>
          job: formattedTasks,
        }

        // Apply PreReqs to Job Request
        if (Array.isArray(this.jobObject.silentOptionsSelected)) {
          payload.prerequisites = [];
          this.jobObject.silentOptionsSelected.forEach((prereq) => {
            if (Array.isArray(prereq.applications)) {
              prereq.applications.forEach((prereqApp) => {
                const createConfigApp = this.createConfig.applications.find((app) => app.appId === prereqApp.appId);
                const version = prereqApp.versions.find((ver) => ver.id === createConfigApp.appVersionId);
                payload.prerequisites.push({
                  "key": prereqApp.appName,
                  "subModels": prereqApp.subModels,
                  "releaseVersion": version.code ? version.code : null,
                  "releaseVersionId": version.id ? version.id : null,
                  "category": prereq.category,
                  "type": prereq.actionType,
                  "isSilentJob": true,
                  "applicationId": prereqApp.appId,
                });
              })
            }
          })
        }

        if (!this.$auth.isAuthenticated) {
          return;
        }

        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;

        payload.isInService = true;

        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/sensors/jobs/templates/${this.preloadJob._id}`, 
          {
            method: 'PATCH',
            body: JSON.stringify(payload),
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to get Gateways
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if ([502, 503].includes(response.status)) {
            this.updateTemplate();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            alert('Template/release updated.');
            this.$emit('return');
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to patch template due to an error.', type: 'error'});
        }
      }
    },
  },
  computed: {
    filterSectionHeight() {
      this.refreshKey;
      const filterSectionDOM = document.getElementById("jobDescription");
      return filterSectionDOM ? filterSectionDOM.offsetHeight : 0;   
    },
  },
  props: ["details", 'return', 'preloadJob'],
};
</script>

<style lang="scss" scoped>
  .jobs-body-inspector {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 50%;
    padding: .75em;
    border-radius: .25em;
    border: 1px solid #f1f1f1;

    small {
      display: 'inline-block';
    }

    &__header {
      width: 100%;
    }

    &__details {
      display: flex;
      font-size: smaller;
      color: #484848;
      flex: 1;
      flex-direction: column;
      margin-top: 1em;
    }

    &__job-item {
      display: flex;
      flex-direction: column;
      margin: .75em;
      padding: 2.5em;
      border-radius: 3px;
      border: 1px solid rgba(0, 0, 0, .05);
      background: rgba(0, 0, 0, .03);
      

      p, .create-job__list-item {
        margin: 0;
      }

      strong {
        min-width: 15em;
        display: inline-block;
      }

      span {
        font-size: .90em;
      }
    }

    input, .create-job-select-container {
      border: 1px solid #f1f1f1;
    }

    .-small-text {
      font-size: .9em;
    }

    .create-job-tree-item {
      margin-left: 1em;
    }
    .text-area {
      outline: none;
      background: white;
      padding: 1em;
      border: 1px solid #f2f2f2;
      display: block;
    }
  }
</style>
